export default __webpack_public_path__ + "static/HeldaneDisplayWeb-Bold-f63deaa7603fd0fd3161da83d17bc5a2.woff2";